// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Soil Sampling Points Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Soil Sampling Points Worker')

  // $FlowFixMe
  const JobWorker = require('worker-loader?name=[hash].sampling-points.wrkr.js!./worker.js')
  worker = new JobWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
